(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/member-popover-item.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/member-popover-item.js');
'use strict';

const SPACEBAR_KEY_CODE = 32;
const ENTER_KEY = 13;
const MemberPopoverItem = _ref => {
  let children = _ref.children,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick;
  const handleKeyDown = e => {
    switch (e.keyCode) {
      case SPACEBAR_KEY_CODE:
      case ENTER_KEY:
        e.stopPropagation();
        e.preventDefault();
        onClick && onClick();
        break;
      default:
    }
  };
  return React.createElement("li", {
    className: "padding-v-1 syndicate-member-item padding-left-1 js-clickable clickable-list-group-item-default",
    onClick: onClick,
    onKeyDown: handleKeyDown,
    role: "button",
    tabIndex: 0
  }, children);
};
svs.arena.pages.teams.components.MemberPopoverItem = MemberPopoverItem;

 })(window);